export const getFrequencyChoices = () => {
  return [
    { id: 1, name: 'Daily' },
    { id: 7, name: 'Weekly (recommended)' },
    { id: 30, name: 'Monthly' },
  ];
};
